import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { Text, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { mapShippingMethods } from '../../../mappers/view/shipping-methods.js';
import '../../../mappers/errors-mapping.js';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/locations';
import { ShippingMethodsList } from '../../modules/ShippingMethods/components/ShippingMethodsList.js';
import { ShippingMethodInfo } from '../../modules/ShippingMethods/components/ShippingMethodInfo.js';
import { PickupPointsContainer } from '../../modules/ShippingMethods/containers/PickupPointsContainer.js';
import '../../modules/ShippingMethods/containers/StoresFinderContainer.js';
import { PickupStoresContainer } from '../../modules/ShippingMethods/containers/PickupStoresContainer.js';
import { useShippingMethodsList } from '../../modules/ShippingMethods/hooks/use-shipping-methods-list.js';
import { ShippingMethodPlaceholder } from './components/ShippingMethodPlaceholder.js';

const AlternativeShippingMethodsList = ({ labels , onSubmit , onModalClose , selectedShippingMethod , onStoreSelect , onPickupPointSelect , selectedStore , selectedPickupPoint  })=>{
    const { locale  } = useIntl();
    const { shippingMethodsLogos  } = useCheckoutSettings();
    const { shippingMethodList , isLoading , reloadShippingMethods , error  } = useShippingMethodsList();
    const [selectedAlternativeShippingMethod, setSelectedAlternativeShippingMethod] = React.useState(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method);
    const shippingMethodInfo = ({ price , logo , isFree  })=>/*#__PURE__*/ React.createElement(ShippingMethodInfo, {
            price: price,
            logo: logo,
            isFree: isFree
        })
    ;
    const items = mapShippingMethods({
        logos: shippingMethodsLogos,
        locale,
        shippingMethodList,
        shippingMethodInfo
    });
    React.useEffect(()=>{
        reloadShippingMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleShippingMethodChange = React.useCallback((method)=>{
        setSelectedAlternativeShippingMethod(method);
    }, []);
    const Modal = ()=>{
        switch(selectedAlternativeShippingMethod){
            case ShippingMethod.Pickup:
                return /*#__PURE__*/ React.createElement(PickupStoresContainer, {
                    onStoreSelect: onStoreSelect,
                    selectedStore: selectedStore
                });
            case ShippingMethod.PickupPoint:
                return /*#__PURE__*/ React.createElement(PickupPointsContainer, {
                    onPickupPointSelect: onPickupPointSelect,
                    selectedPickupPoint: selectedPickupPoint
                });
            default:
                return null;
        }
    };
    const handleSubmit = ()=>{
        onSubmit(selectedAlternativeShippingMethod);
    };
    const hasValidationError = !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched);
    return /*#__PURE__*/ React.createElement("div", {
        className: "alternative-shipping-methods"
    }, isLoading && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        color: "text-secondary"
    }, labels.description), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: "alternative-shipping-methods__button-placeholder"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "48px"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        rx: "4",
        height: "48px",
        fill: "currentColor"
    })))), error && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        title: labels.errorTitle
    }, labels.errorDescription), /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        caption: labels.back,
        onClick: onModalClose
    })), !isLoading && (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, labels.description), /*#__PURE__*/ React.createElement(ShippingMethodsList, {
        handleChange: handleShippingMethodChange,
        shippingMethodItems: items,
        selectedShippingMethod: (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method : '',
        hasValidationError: hasValidationError
    }), /*#__PURE__*/ React.createElement(Button, {
        style: {
            width: '100%'
        },
        caption: labels.buttonCaptionLabel,
        onClick: handleSubmit
    }), /*#__PURE__*/ React.createElement(Modal, null)));
};

export { AlternativeShippingMethodsList };
//# sourceMappingURL=AlternativeShippingMethodsList.js.map
